import { useId } from 'react';
import { FieldDescription, FieldError, Textarea } from '@monksflow/monks-ui';
import { AlignLeftIcon } from 'lucide-react';
import { KnowledgeBaseFormField } from '../KnowledgeBaseFormField';
import { KnowledgeBaseFormDescriptionProps } from './KnowledgeBaseFormDescription.types';
import { useTranslation } from 'react-i18next';

const MAX_LENGTH = 200;

export const KnowledgeBaseFormDescription = ({
  description,
  setDescription,
  error,
}: KnowledgeBaseFormDescriptionProps) => {
  const { t } = useTranslation('knowledge');

  const fieldId = useId();
  const errorId = useId();
  const descriptionId = useId();
  const counterId = useId();

  return (
    <KnowledgeBaseFormField
      icon={<AlignLeftIcon />}
      title={t('knowledgeBases.knowledgeBaseFormDescription.description')}
      description={t('knowledgeBases.knowledgeBaseFormDescription.giveADescriptionToExplain')}
      required={true}
      fieldId={fieldId}
      descriptionId={descriptionId}
    >
      <Textarea
        id={fieldId}
        placeholder={t('knowledgeBases.knowledgeBaseFormDescription.eGBrandSPurpose')}
        rows={3}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        maxLength={MAX_LENGTH}
        required
        error={Boolean(error)}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${descriptionId} ${errorId}` : `${descriptionId} ${counterId}`}
      />
      {error ? (
        <FieldError id={errorId}>{error}</FieldError>
      ) : (
        <FieldDescription id={counterId}>
          {description.length}/{MAX_LENGTH}
        </FieldDescription>
      )}
    </KnowledgeBaseFormField>
  );
};

KnowledgeBaseFormDescription.displayName = 'KnowledgeBaseFormDescription';
